module.exports = __webpack_public_path__ + "static/img/hz_banner.7879fd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hz_banner.png
// module id = 3iWz
// module chunks = 0